import { t } from "../translate";
import PrimaryButton from "../components/atomics/primary-button";
import ModalLayout, { ModalLayoutProps } from "../components/layouts/modal-layout";
import styles from "./request-summary.module.scss";
import { CityModel, RenterCompanyProfileCreateModel } from "../service";
import { Col, Form, Input, Row } from "antd";
import { useEffect } from "react";
import TextArea from "antd/lib/input/TextArea";

type UpdateProfileModalProps = {
    onApprove: (profileData: RenterCompanyProfileCreateModel | undefined) => void;
    profileData: RenterCompanyProfileCreateModel | undefined;
    cities?: CityModel[] | undefined;
} & ModalLayoutProps;

const UpdateRenterProfileModal = (props: UpdateProfileModalProps) => {
    const [form] = Form.useForm();

    useEffect(() => {
        form.setFieldsValue(props.profileData);
        //eslint-disable-next-line
    }, [props.profileData]);

    const onProfileUpdateFormFinish = (values: RenterCompanyProfileCreateModel | undefined) => {
        props.onApprove(values);
    };

    return (
        <ModalLayout show={props.show} onCloseClick={props.onCloseClick}>
            <h3 style={{ textAlign: "center", marginBottom: "1rem" }}>{t("customer-profile.update.title")}</h3>
            <div className={styles.lightboxContent}>
                <Form
                    name="update-profile"
                    initialValues={props.profileData}
                    form={form}
                    onFinish={onProfileUpdateFormFinish}
                    layout="vertical"
                >
                    <Row gutter={[16, 0]}>
                        <Col xs={24} md={{offset:6,span:12}}>
                            <Form.Item 
                                label={t("customer-profile.update.name")} 
                                name="name" 
                                rules={[
                                        {pattern: /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]*$/,message: t('update-renter-profile-modal.name-field')}
                                    ]}
                                >
                                <Input placeholder={t("customer-profile.update.name")} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={{offset:6,span:12}}>
                            <Form.Item label={t("customer-profile.update.lastname")} name="lastname"
                               rules={[
                                {pattern: /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]*$/,message: t('update-renter-profile-modal.surname-field')}
                            ]}
                            >
                                <Input placeholder={t("customer-profile.update.lastname")} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={{offset:6,span:12}}>
                            <Form.Item label={t("customer-profile.update.email")} name="email">
                                <TextArea placeholder={t("customer-profile.update.email")} />
                            </Form.Item>
                        </Col>
                        <Col xs={24} md={{offset:6,span:12}}>
                            <PrimaryButton type="primary" htmlType="submit">
                                {t("common.approveNow")}
                            </PrimaryButton>
                        </Col>
                    </Row>
                </Form>
            </div>
        </ModalLayout>
    );
};

export default UpdateRenterProfileModal;
